import { useCallback } from 'react';
import { handleOnChange } from './handleOnChange';
export var denormalizeValue = function denormalizeValue(value, multiple) {
  return multiple ? value : value[0];
};
export var useOnToggleAll = function useOnToggleAll(setInternalValue, internalOptions, internalValue, onChange) {
  return useCallback(function () {
    var selectAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (!selectAll) {
      handleOnChange([], onChange);
      return setInternalValue([]);
    }

    if (internalValue.length === internalOptions.length) {
      handleOnChange([], onChange);
      return setInternalValue([]);
    }

    var internalOptionValues = internalOptions.map(function (option) {
      return option.value;
    });
    handleOnChange(internalOptionValues, onChange);
    return setInternalValue(internalOptionValues);
  }, [setInternalValue, internalOptions, internalValue]);
};